import { useThemeStore } from "@/store/theme";

class ChartData {
  constructor(
    public options: any = {},
    public series: any[] = [],
    public legends: Legends[] = []
  ) {}
}

class Legends {
  constructor(
    public title: String = "",
    public number: Number = 0,
    public tooltip: String = "",
    public color: String = ""
  ) {}
}

const basic = {
  tooltip: {
    enabled: false,
  },
  selection: {
    enabled: false,
  },
  states: {
    active: {
      filter: {
        type: "none",
      },
    },
    hover: {
      filter: {
        type: "none",
      },
    },
  },
};

const studentsChart = {
  colors: [
    useThemeStore.theme?.colors["h-primary"]?.[500],
    useThemeStore.theme?.colors["h-primary"]?.[500],
    "#167F1A",
  ],
  fill: {
    colors: [
      useThemeStore.theme?.colors["h-primary"]?.[500],
      useThemeStore.theme?.colors["h-primary"]?.[500],
      "#167F1A",
    ],
  },
  legend: {
    show: false,
  },
  dataLabels: {
    style: {
      fontSize: "15px",
      fontWeight: "bold",
      colors: ["#111"],
    },
    dropShadow: {
      enabled: false,
    },
  },
  plotOptions: {
    pie: {
      expandOnClick: false,
      donut: {
        labels: {
          show: true,
          name: {
            show: true,
          },
          value: {
            show: true,
            fontWeight: "bold",
            fontSize: "20px",
          },
          total: {
            show: true,
            label: "Total de Alunos",
            color: "#000",
          },
        },
      },
    },
  },
};

const attentionChart = {
  fill: {
    colors: [
      useThemeStore.theme?.colors["h-secondary"]?.[500],
      "#97979B",
    ],
  },
  legend: {
    show: false,
  },
  dataLabels: {
    style: {
      fontSize: "15px",
      fontWeight: "bold",
      colors: ["#fff", "#111"],
    },
    dropShadow: {
      enabled: false,
    },
  },
  plotOptions: {
    pie: {
      expandOnClick: false,
    },
  },
};

const colNames = [
  "Nome do curso",
  "Usuários ativos",
  "Usuários inativos",
  "Usuários concludentes",
  "Atenção ligada",
  "Atenção desligada",
  "Média das notas",
  "Total de alertas",
  "Total de alunos",
];

const exportOptions = {
  std: { ...basic, ...studentsChart },
  att: { ...basic, ...attentionChart },
};

export { ChartData, colNames, exportOptions, Legends };
